<template>
  <div class="loading">
      <div class="marker"></div>
      <span class="loadingtext">加载中{{text}}</span>
  </div>
</template>

<script>
  export default {
    name: 'loading',
    data () {
      return {
          text:'',
        isload: ''
      }
    },
    props:["isloading"],
    mounted(){
        var _this=this;
      _this.isload=setInterval(function () {
          if(_this.text.length<3){
            _this.text+=".";
          }else{
              _this.text='';
          }
      },500);
    },
    watch:{
        isloading:{ //深度监听，可监听到对象、数组的变化
          handler (newV, oldV) {
              var _this=this;
            if(!newV){
              clearInterval(_this.isload);
            } else{
              _this.isload=setInterval(function () {
                if(_this.text.length<3){
                  _this.text+=".";
                }else{
                    _this.text='';
                }
              },500);
            }
          },
          deep:true
        }
    }
  }
</script>

<style scoped>
  .loading{
    text-align: center;
  }
  .marker{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    z-index: 500;
    background-color: rgba(255,255,255,0.5);
  }
  .loadingtext{
    position: absolute;
    top:49%;
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue